import React from 'react';
import { X, Eye } from 'lucide-react';
import Campaigns from '@/components/previews/Campaigns';

export function CampaignPreviewModal({ isOpen, onClose, formData, selectedCompany, micrositeData }) {
  if (!isOpen) return null;

  const previewData = {
    formData,
    selectedCompany,
    micrositeData
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-card rounded-lg shadow-xl w-full max-w-7xl max-h-[95vh] flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-2">
      
            <h3 className="text-lg font-semibold text-foreground"></h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto">
          <Campaigns 
            previewData={previewData}
            isPreview={true}
          />
        </div>
      </div>
    </div>
  );
}
